export const TEST_IDS = {
  ORDER_ITEMS: 'order-items',
  ORDER_ITEM: 'order-item',
  ORDER_ADD_ONS: 'order-add-ons',
  ORDER_ADD_ON: 'order-add-on',
  STICKY_FOOTER_CONTAINER: 'sticky-mobile-footer-container',
}

export const CLASSES = {
  ADD_ONS_ENABLED: 'add-ons-enabled',
  PURCHASE_CONFIRMATION: 'purchase-confirmation',
  WITH_TIMER: 'with-timer',
  WITH_FOOTER: 'with-footer',
  WITH_STICKY_FOOTER: 'with-sticky-footer',
  MOBILE_APP: 'mobile-app',
  EVENTS: 'events',
  CAN_USE_WEBP: 'webp',
}

export const ELEMENT_IDS = {
  MAIN_HEADER: 'header',
  MAIN_CONTENT: 'main-content',
  STICKY_HEADER: 'sticky-header',
  ORDER_SUMMARY_CONTAINER: 'order-summary-container',
  RESERVATION_HEADER: 'reservation-header',
  STICKY_FOOTER_CONTAINER: 'sticky-mobile-footer-container',
  AUTH_WIDGET: 'auth-widget',
}

/**
 * TODO: merge with CLASSES
 */
export const GLOBAL_CLASSES = {
  TypoStandard: 'mw--typo-standard',
  Reset: 'mw--style-reset',
  NavLink: 'mw--nav-link', // header or footer nav
}

export const PAYMENT_ELEMENT_ID = 'payment-element'
